var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import { Chat } from './components/Chat';
import { Pixi } from './components/Pixi';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  width: 100vw;\n  min-width: 760px;\n"], ["\n  display: flex;\n  width: 100vw;\n  min-width: 760px;\n"])));
var App = function () {
    var _a = useState([]), chatList = _a[0], setChatList = _a[1];
    var _b = useState(0), activeChatIndex = _b[0], setActiveChatIndex = _b[1];
    var chatListRef = useRef(null);
    var activeItemRef = useRef(null);
    var textAreaRef = useRef(null);
    var createNewChat = function (position) {
        var filteredState = chatList.filter(function (c) { return c.messages.length > 0; });
        setChatList(__spreadArrays(filteredState, [
            {
                messages: [],
                inputValue: '',
                pin: position,
            },
        ]));
        setActiveChatIndex(filteredState.length);
    };
    var updateMessageHandler = function (value, index) {
        setChatList(function (current) {
            var tmp = __spreadArrays(current);
            tmp[index].inputValue = value;
            return tmp;
        });
    };
    var submitMessageHandler = function (index) {
        if (chatList[index].inputValue === '') {
            return;
        }
        var date = new Date();
        var tmp = __spreadArrays(chatList);
        tmp[index].messages.push({
            id: String(tmp[index].messages.length + 1),
            author: 'Sota Ohara',
            createdAt: date.getFullYear() + "/" + date.getMonth() + "/" + date.getDate(),
            message: tmp[index].inputValue,
        });
        tmp[index].inputValue = '';
        setChatList(tmp);
        focusOnTextarea();
    };
    var pinList = useMemo(function () {
        return chatList.map(function (c) { return c.pin; });
    }, [chatList]);
    var clickPinHandler = function (index) {
        clearEmptyChats();
        setActiveChatIndex(index);
    };
    useEffect(function () {
        if (!activeItemRef.current) {
            return;
        }
        var chatListRefCurrent = chatListRef.current;
        var activeRefCurrent = activeItemRef.current;
        chatListRefCurrent.scrollTop = activeRefCurrent.offsetTop - 54;
        focusOnTextarea();
    }, [activeChatIndex]);
    var clearEmptyChats = function () {
        var filteredChatList = chatList.filter(function (c) { return c.messages.length > 0; });
        setChatList(filteredChatList);
    };
    var focusOnTextarea = function () {
        var textareaRefCurrent = textAreaRef.current;
        textareaRefCurrent.focus();
    };
    return (React.createElement(Wrapper, null,
        React.createElement(Pixi, { pins: pinList, addPin: createNewChat, clickPinHandler: clickPinHandler }),
        React.createElement(Chat, { chatList: chatList, activeChatIndex: activeChatIndex, updateMessageHandler: updateMessageHandler, submitMessageHandler: submitMessageHandler, chatListRef: chatListRef, activeItemRef: activeItemRef, textAreaRef: textAreaRef })));
};
export { App };
var templateObject_1;
